import React, { useEffect, useState } from "react";
import { tallyAdminApi } from "../../../../services/tallyAdminApi";

/**
 * Link from GET /api/tally-agent/installer. The file itself lives at
 * TALLY_AGENT_INSTALLER_URL. Downloading it does not connect a computer.
 */
export const TallyConnectorDownload: React.FC = () => {
  const [url, setUrl] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    void tallyAdminApi
      .installerUrl()
      .then((next) => {
        if (!cancelled) {
          setUrl(next);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setUrl(null);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (url === undefined) {
    return null;
  }

  if (!url) {
    return (
      <p className="text-caption font-caption text-subtext-color">
        The Tally connector installer is not published yet. Downloading it does not connect a computer.
      </p>
    );
  }

  return (
    <a
      href={url}
      className="text-body font-body text-brand-700 hover:underline w-fit"
    >
      Download the Tally connector
    </a>
  );
};
